import { Navigate } from "@tanstack/react-router";
import { useMerchantDraft } from "@/api/workspace-merchants";
import { AddMerchantWizard } from "@/components/add-merchant/add-merchant-wizard";
import { useWorkspaceId } from "@/providers/MerchantProvider";

export function AddMerchantPage() {
  const workspaceId = useWorkspaceId();
  const { data: draft, isLoading } = useMerchantDraft({ pollUntilConnected: true });

  if (!workspaceId || isLoading) return null;
  if (!draft) return <Navigate to="/workspace/$workspaceId/settings/merchants" params={{ workspaceId }} />;
  return <AddMerchantWizard key={draft.id} draft={draft} workspaceId={workspaceId} />;
}
